module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_ks_pljs@2x.ea4312e5.png";